import React, { useState, useEffect, useRef, forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Api from "../Api/Api.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUpRightFromSquare,
  faGlobe,
  faShare,
  faThumbsUp,
  faComment,
  faShareFromSquare,
  faArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  Box,
  Container,
  FormHelperText,
  Card,
  CardContent,
  CardActions,
  IconButton,
  Zoom,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import {
  AccountCircle,
  ArrowForward,
  ArrowUpward,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  PersonOutline,
  Print,
  Refresh,
  Send,
  ThumbDown,
  ThumbUp,
} from "@mui/icons-material";
import { faArrowAltCircleUp } from "@fortawesome/free-regular-svg-icons";
import config from "../config/config";
import api from "../Api/base";
import { useAuth } from "react-oidc-context";
import { setLoading } from "../App";

const UserChat = ({ message, gender }) => {
  return (
    <Box className="flex flex-row gap-2 items-end ml-auto max-w-lg">
      <Box className="bg-gray-200 p-2 rounded-t-xl rounded-l-xl mb-1">
        <Typography
          variant="body1"
          wrap
          sx={{
            wordWrap: "break-word", // For legacy browsers
            overflowWrap: "break-word", // Modern standard
            wordBreak: "break-word", // For non-CJK languages
            hyphens: "auto", // Add hyphens when breaking if supported
          }}
        >
          {message}
        </Typography>
      </Box>

      <img
        className="w-11 h-11 md:w-12 md:h-12 p-1 ml-2 md:ml-4 rounded-full bg-gray-200"
        src={
          gender === "male"
            ? "/male_avatar.webp"
            : gender === "female"
            ? "/female_avatar.png"
            : "https://i.postimg.cc/s23J2htT/4.png"
        }
        alt="User Avatar"
      />
    </Box>
  );
};

const AssistantChat = forwardRef(({ message }, ref) => {
  return (
    <Box className="flex flex-row gap-2 items-end max-w-lg" ref={ref}>
      <img
        className="w-11 h-11 md:w-12 md:h-12 p-1 mr-2 md:mr-4 rounded-full bg-gray-200"
        src="/surgeon.png"
        alt="Assistant Avatar"
      />
      <Box className="bg-gray-200 p-2 rounded-t-xl rounded-r-xl mb-1">
        <Typography
          variant="body1"
          wrap
          sx={{
            wordWrap: "break-word", // For legacy browsers
            overflowWrap: "break-word", // Modern standard
            wordBreak: "break-word", // For non-CJK languages
            hyphens: "auto", // Add hyphens when breaking if supported
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
});

const QuestionnaireFormIntake = () => {
  const navigate = useNavigate();
  // const [currentIndex, setCurrentIndex] = useState(9);
  // const initialFormData = {
  // 	age: "42",
  // 	gender: "male", // "Male"
  // 	q1: "আজকে আপনার কি সমস্যা আছে?", // "What problem do you have today?"
  // 	q2: "আপনি কত দিন ধরে এই সমস্যা অনুভব করছেন?", // "How long have you been experiencing this problem?"
  // 	q3: "আপনার কি পূর্বে কোনো অসুস্থতা ছিল?", // "Did you have any previous illnesses?"
  // 	q4: "আপনি কি কোনো ওষুধ সেবন করেন?", // "Do you take any medications?"
  // 	q5: "আপনার পরিবারে কি এই ধরনের সমস্যা কারো আছে?", // "Does anyone in your family have this type of problem?"
  // 	q6: "আপনার দৈনন্দিন কাজকর্মে কি এই সমস্যা প্রভাব ফেলছে?", // "Is this problem affecting your daily activities?"
  // 	q7: "আপনি কি আগে কোনো স্বাস্থ্য নিয়েছেন এই সমস্যার জন্য?", // "Have you received any treatment for this problem before?"
  // 	q8: "আপনার খাদ্যাভ্যাস কেমন?", // "How are your eating habits?"
  // 	q9: "আপনি কি নিয়মিত ব্যায়াম করেন?", // "Do you exercise regularly?"
  // 	q10: "", // "How are your sleeping habits?"
  // 	a1: "আমি প্রায় দুই সপ্তাহ ধরে মাথাব্যথা এবং মাঝে মাঝে মাথা ঘোরা অনুভব করছি।", // "I have been experiencing headaches and occasional dizziness for about two weeks."
  // 	a2: "প্রায় দুই সপ্তাহ ধরে।", // "For about two weeks."
  // 	a3: "হ্যাঁ, আমার উচ্চ রক্তচাপ আছে।", // "Yes, I have high blood pressure."
  // 	a4: "হ্যাঁ, আমি রক্তচাপের ওষুধ খাই।", // "Yes, I take medication for blood pressure."
  // 	a5: "হ্যাঁ, আমার বাবার উচ্চ রক্তচাপ ছিল।", // "Yes, my father had high blood pressure."
  // 	a6: "হ্যাঁ, কাজে মনোযোগ দিতে সমস্যা হচ্ছে এবং দুপুরের পর খুব ক্লান্তি লাগে।", // "Yes, I have trouble concentrating at work and feel very tired after noon."
  // 	a7: "না, এই সমস্যার জন্য আগে কোনো স্বাস্থ্য নেইনি।", // "No, I haven't received any treatment for this problem before."
  // 	a8: "আমি সকালে নাস্তা করি না, দুপুরে ভাত খাই, রাতে হালকা খাবার খাই।", // "I don't eat breakfast, have rice for lunch, and eat light food at night."
  // 	a9: "না, নিয়মিত ব্যায়াম করি না।", // "No, I don't exercise regularly."
  // 	a10: "", // "I have trouble sleeping at night, often wake up in the middle of the night."
  // };

  const [currentIndex, setCurrentIndex] = useState(1);
  const initialFormData = {
    age: "",
    gender: "",
    q1: "আজকে আপনার কি সমস্যা আছে?",
    q2: "",
    q3: "",
    q4: "",
    q5: "",
    q6: "",
    q7: "",
    q8: "",
    q9: "",
    q10: "",
    a1: "",
    a2: "",
    a3: "",
    a4: "",
    a5: "",
    a6: "",
    a7: "",
    a8: "",
    a9: "",
    a10: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const auth = useAuth();

  const [isComplete, setIsComplete] = useState(false);
  const [prescription, setPrescription] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);
  const messagesEndRef = useRef(null);
  const [patientId, setPatientId] = useState(0);
  const chatContainerRef = useRef(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [appointmentTaken, setAppointmentTaken] = useState(false);
  const [takingAppointment, setTakingAppointment] = useState(false);
  const [feedbackValue, setFeedbackValue] = useState(1);
  const [comment, setComment] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleFeedbackChange = (event) => {
    setFeedbackValue(event.target.value);
  };

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleSubmitFeedback = async () => {
    // Here you would typically send the feedback to your backend
    const result = await api.post(
      auth.isAuthenticated ? Api.MUKTIBD_USER_API : Api.SPOKEN_ENGLISH_API,
      {
        task: "set_user_feedback",
        thumbs_up: feedbackValue,
        comment: "comment",
      }
    );

    if (result.success) {
      setSubmitted(true);
      setOpenSnackbar(true);
    }

    // Reset form after submission if desired
    // setFeedbackValue('');
    // setComment('');
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  // const componentRef = useRef();
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [currentIndex]);

  const handleNext = async () => {
    if (!formData[`a${currentIndex}`])
      return alert("উত্তর দিন এবং আবার চেষ্টা করুন!");

    if (currentIndex === 10) {
      //console.log(formData);
      //setPrescription(response.data);
      setIsComplete(true);
      return;
    }
    setIsLoading(true);

    if (patientId === 0 && auth.isAuthenticated) {
      await fetchUser();
    }

    // Send collected responses to API to get next question
    const requestData = {
      task: "getNextQuestionForPrescription",
      formData: formData,
      patient_id: patientId,
    };
    //console.log(requestData);
    const headers = { headers: { "Content-Type": "application/json" } };
    const url = Api.SPOKEN_ENGLISH_API;
    const response = await api.post(url, requestData);

    if (response.success) {
      const responseObject = JSON.parse(response.data);
      if ("medicine_list" in responseObject) {
        setPrescription(responseObject);
        //console.log(response.data);
        setIsComplete(true);
      } else {
        setFormData((prev) => ({
          ...prev,
          [`q${currentIndex + 1}`]: responseObject.question || "",
        }));
      }
    }
    //console.log(response.data);
    setIsLoading(false);
    setCurrentIndex(currentIndex + 1);
    /*
    if (currentIndex === 10) {
      console.log(formData);
      setPrescription(response.data);
      setIsComplete(true);
      return;
    }*/
    /* 
    const response = await axios.post("/api/get-next-question", {
      ...formData,
    });*/

    //const response={'data':{question:"What is your age?"}}
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    //console.log(name, value);
    setFormData({ ...formData, [name]: value });
    //setFormData({ ...formData, [`a${currentIndex}`]: e.target.value });
  };

  const handlePrint = () => {
    // Create a formatted print content
    const newWindow = window.open("", "", "width=800,height=600");
    newWindow.document.write(`
      <html>
        <head>
          <title>স্বাস্থ্য উপদেশ</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              padding: 20px;
              max-width: 800px;
              margin: 0 auto;
              color: #333;
            }
            .header {
              text-align: center;
              margin-bottom: 20px;
              padding-bottom: 10px;
              border-bottom: 2px solid #3b82f6;
            }
            h2 { 
              color: #1e40af; 
              margin-bottom: 5px;
            }
            .patient-info {
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;
              background: #f0f9ff;
              padding: 10px;
              border-radius: 5px;
            }
            .section {
              margin-bottom: 20px;
            }
            .section-title {
              color: #3b82f6;
              border-bottom: 1px solid #ddd;
              padding-bottom: 5px;
              margin-bottom: 10px;
            }
            ul { 
              list-style-type: disc; 
              margin-left: 20px; 
              padding-left: 15px;
            }
            li {
              padding: 5px 0;
            }
            .footer {
              margin-top: 30px;
              padding-top: 10px;
              border-top: 1px solid #ddd;
              font-style: italic;
              font-size: 12px;
              color: #666;
            }
            .note {
              background: #f9f9f9;
              padding: 10px;
              border-left: 3px solid #3b82f6;
              margin-top: 20px;
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h2>স্বাস্থ্য উপদেশ</h2>
            <p>তারিখ: ${new Date().toLocaleDateString()}</p>
          </div>
          
          <div class="patient-info">
            <div>
              <strong>বয়স:</strong> ${formData.age} বছর
            </div>
            <div>
              <strong>লিঙ্গ:</strong> ${
                formData.gender === "male"
                  ? "পুরুষ"
                  : formData.gender === "female"
                  ? "মহিলা"
                  : formData.gender === "other"
                  ? "অন্যান্য"
                  : ""
              }
            </div>
          </div>
          
          <div class="section">
            <h3 class="section-title">পরীক্ষা সমূহ:</h3>
            <ul>
              ${prescription?.diagnostic_test_list
                ?.map((test) => `<li>${test}</li>`)
                .join("")}
            </ul>
          </div>
          
          <div class="section">
            <h3 class="section-title">ঔষধ সমূহ:</h3>
            <ul>
              ${prescription?.medicine_list
                ?.map((med) => `<li>${med}</li>`)
                .join("")}
            </ul>
          </div>
          
          <div class="section">
            <h3 class="section-title">পরামর্শ:</h3>
            <ul>
              ${prescription?.advice_list
                ?.map((advice) => `<li>${advice}</li>`)
                .join("")}
            </ul>
          </div>
          
          <div class="note">
            <p><sup>1.</sup> এটি একটি প্রাথমিক রূপরেখা। রেজিস্টার্ড ডাক্তারের পরামর্শ নিয়ে ওষুধ সেবন করুন।</p>
          </div>
        </body>
      </html>
    `);

    newWindow.document.close();
    newWindow.focus();
    setTimeout(() => {
      newWindow.print();
      newWindow.close();
    }, 500);
  };

  const handleRefresh = () => {
    setFormData(initialFormData);
    setCurrentIndex(1); // Restart from the first question
    setIsComplete(false); // Go back to question-answering mode
    setPrescription(null); // Clear prescription data
  };
  const [containerHeight, setContainerHeight] = useState(0);
  const [chatAreaHeight, setChatAreaHeight] = useState(0);
  const updateHeight = () => {
    // Assuming the navbar height is 64px (adjust as needed)
    const navbarHeight = config.topbarHeight;
    const windowHeight = window.innerHeight;
    setContainerHeight(windowHeight - navbarHeight);
    // setChatAreaHeight(windowHeight - navbarHeight - 64);
  };

  useEffect(() => {
    setLoading(false);
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const getUserID = async () => {
    const result = await api.post(
      "https://tib60ktrrj.execute-api.us-east-1.amazonaws.com/prod",
      {
        task: "getUserInfo",
      }
    );
    console.log("Hereeeee:", result);
    if (result.success) {
      console.log("Hereeeee:", result.data[0].id);
      return result.data[0].id;
    } else {
      return 0;
    }
  };

  const fetchUser = async () => {
    const id = await getUserID();
    setPatientId(id);
  };

  const submitAppointmentRequest = async () => {
    setTakingAppointment(true);
    const result = await api.post(Api.PATIENT_API, {
      task: "setMuktiBDAppointmentRequest",
      name: name,
      phone: phone,
      problems: prescription.problem_list,
      specialization: prescription.specialization_referral[0] ?? "",
    });
    if (result.success) {
      setAppointmentTaken(true);
    }
    setTakingAppointment(false);
  };

  useEffect(() => {
    if (auth.isAuthenticated) fetchUser();
  }, [auth]);

  return (
    <Box
      className="max-w-2xl mx-auto"
      style={{ height: `${containerHeight}px` }}
    >
      {!hasStarted && (
        <div
          className="fixed flex justify-center items-center max-w-md inset-x-0 mx-auto px-8"
          style={{
            height: `calc(${containerHeight}px - ${config.topbarHeight}px)`,
          }}
        >
          <Zoom in={true}>
            <Box className="w-full flex flex-col items-center relative">
              <Paper
                id="printable-section"
                className="p-4 bg-blue-50 rounded-lg shadow-md w-full"
                elevation={3}
              >
                <Box className="text-center mb-3 flex flex-row items-center justify-center w-full">
                  <PersonOutline
                    sx={{
                      fontSize: 35,
                    }}
                  />
                  <h2 className="text-xl font-bold">ব্যক্তিগত তথ্য</h2>
                </Box>

                <Box className="grid grid-cols-1 gap-4">
                  <FormControl fullWidth variant="outlined" size="small">
                    {/* <InputLabel>বয়স</InputLabel> */}
                    <TextField
                      name="age"
                      value={formData.age}
                      onChange={handleChange}
                      variant="outlined"
                      type="number"
                      InputProps={{
                        inputProps: {
                          min: 0,
                          max: 120,
                        },
                      }}
                      label="বয়স"
                      className="bg-gray-50"
                      size="small"
                    />
                  </FormControl>
                  <FormControl fullWidth variant="outlined" size="small">
                    <InputLabel id="gender-label">লিঙ্গ</InputLabel>
                    <Select
                      labelId="gender-label"
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      label="লিঙ্গ"
                      className="bg-gray-50"
                      size="small"
                    >
                      {/* <MenuItem value="">নির্বাচন করুন</MenuItem> */}
                      <MenuItem value="male">পুরুষ</MenuItem>
                      <MenuItem value="female">মহিলা</MenuItem>
                      <MenuItem value="other">অন্যান্য</MenuItem>
                    </Select>
                  </FormControl>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      if (formData.age === "" || formData.gender === "")
                        return alert("দয়া করে সব তথ্য পূরণ করুন!");
                      setHasStarted(true);
                    }}
                    endIcon={<KeyboardArrowRight />}
                    // className="bg-blue-600 hover:bg-blue-700"
                  >
                    শুরু করুন
                  </Button>
                </Box>
                {/* <Divider className="my-4 w-full" /> */}
              </Paper>
              {!auth.isAuthenticated && (
                <h1 className="absolute text-zinc-500 bottom-[-25px]">Guest</h1>
              )}
            </Box>
          </Zoom>
        </div>
      )}

      {hasStarted && (
        <>
          {isComplete && (
            <Box className="max-w-2xl mx-auto p-4 flex flex-col gap-4">
              <Zoom in={true}>
                <Paper
                  className="p-6 bg-blue-50 rounded-lg shadow-md flex flex-col"
                  elevation={3}
                >
                  <Typography
                    variant="h6"
                    className="font-semibold mb-2 text-blue-600 border-b border-gray-200 pb-1"
                  >
                    সমস্যা সমূহ:
                  </Typography>
                  <ul className="list-disc ml-6 my-3">
                    {prescription?.problem_list?.map((problem, index) => (
                      <li key={index} className="py-1 text-gray-800">
                        {problem}
                      </li>
                    ))}
                  </ul>
                  <Divider />
                  <Box className="mt-4">
                    <Typography>
                      {prescription?.specialization_referral.length > 0 && (
                        <>
                          আমরা আপনাকে সুপারিশ করছি যে আপনি{" "}
                          {prescription?.specialization_referral[0]} বিশেষজ্ঞের
                          পরামর্শ নিন।{" "}
                        </>
                      )}
                      আপনি প্রথমে ৪ বছরের অভিজ্ঞতা সম্পন্ন একজন MBBS ডাক্তারের
                      সাথে পরামর্শ করতে পারেন। MBBS ডাক্তারের খরচ হবে ৫০ টাকা।{" "}
                      {prescription?.specialization_referral.length > 0 && (
                        <>
                          এবং {prescription?.specialization_referral[0]}{" "}
                          বিশেষজ্ঞের খরচ হবে ৪০০ টাকা।{" "}
                        </>
                      )}
                      আপনি যদি পরামর্শ চান, তাহলে এখানে আপনার নাম এবং ফোন নম্বর
                      জমা দিন।
                    </Typography>
                    <form
                      className="mt-4 flex flex-col gap-4"
                      onSubmit={submitAppointmentRequest}
                    >
                      <TextField
                        fullWidth
                        label="নাম"
                        variant="outlined"
                        className="mb-2"
                        multiline
                        rows={1}
                        size="small"
                        disabled={appointmentTaken}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                      <TextField
                        fullWidth
                        label="ফোন নম্বর"
                        variant="outlined"
                        className="mb-2"
                        multiline
                        rows={1}
                        size="small"
                        disabled={appointmentTaken}
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        className="bg-green-600 hover:bg-green-700"
                        disabled={appointmentTaken || !name.trim() || !phone.trim()}
                        onClick={() => {
                          navigate("/payment", {
                            state: {
                              amount: 50,
                              name: name,
                              phone: phone,
                              prescription: prescription,
                            },
                          });
                        }}
                      >
                        Pay 50 Taka
                      </Button>
                      <Box className="w-full">
                        <LoadingButton
                          type="submit"
                          variant="contained"
                          color="primary"
                          className="bg-blue-600 hover:bg-blue-700 ml-auto"
                          disabled={appointmentTaken}
                          loading={takingAppointment}
                          startIcon={<Send className="mr-2" />}
                          loadingPosition="start"
                          //   onClick={submitAppointmentRequest}
                        >
                          পরামর্শ নিতে চাই
                        </LoadingButton>
                      </Box>
                    </form>
                    {appointmentTaken && (
                      <Typography className="mt-2 text-green-600 italic">
                        আপনার অনুরোধ জমা নেওয়া হয়েছে। আমরা আপনার সাথে ২৪ ঘন্টা
                        এর মধ্যে যোগাযোগ করব। ধন্যবাদ।
                      </Typography>
                    )}
                  </Box>
                </Paper>
              </Zoom>
              <Zoom in={true}>
                <Paper
                  className="p-6 bg-blue-50 rounded-lg shadow-md"
                  elevation={3}
                >
                  <Box className="bg-white p-2 rounded-lg">
                    <div className="text-center mb-5 pb-2 border-b-2 border-blue-500">
                      <h2 className="text-[#1e40af] mb-1 text-2xl font-bold">
                        স্বাস্থ্য উপদেশ
                      </h2>
                      <p>
                        {"তারিখ: "}
                        {new Date().toLocaleDateString()}
                      </p>
                    </div>

                    <div className="flex justify-between mb-5 bg-blue-50 p-2.5 rounded-md">
                      <div>
                        <strong>{"বয়স: "}</strong>
                        {formData.age} বছর
                      </div>
                      <div>
                        <strong>{"লিঙ্গ: "}</strong>
                        {formData.gender === "male"
                          ? "পুরুষ"
                          : formData.gender === "female"
                          ? "মহিলা"
                          : formData.gender === "other"
                          ? "অন্যান্য"
                          : ""}
                      </div>
                    </div>

                    <Box className="mt-4">
                      <Typography
                        variant="h6"
                        className="font-semibold mb-2 text-blue-600 border-b border-gray-200 pb-1"
                      >
                        পরীক্ষা সমূহ:
                      </Typography>
                      <ul className="list-disc ml-6 mt-3">
                        {prescription?.diagnostic_test_list?.map(
                          (test, index) => (
                            <li key={index} className="py-1 text-gray-800">
                              {test}
                            </li>
                          )
                        )}
                      </ul>
                    </Box>

                    <Box className="mt-4">
                      <Typography
                        variant="h6"
                        className="font-semibold mb-2 text-blue-600 border-b border-gray-200 pb-1"
                      >
                        ঔষধ সমূহ:
                      </Typography>
                      <ul className="list-disc ml-6 mt-3">
                        {prescription?.medicine_list?.map((med, index) => (
                          <li key={index} className="py-1 text-gray-800">
                            {med}
                          </li>
                        ))}
                      </ul>
                    </Box>

                    <Box className="mt-4">
                      <Typography
                        variant="h6"
                        className="font-semibold mb-2 text-blue-600 border-b border-gray-200 pb-1"
                      >
                        পরামর্শ:
                      </Typography>
                      <ul className="list-disc ml-6 mt-3">
                        {prescription?.advice_list?.map((advice, index) => (
                          <li key={index} className="py-1 text-gray-800">
                            {advice}
                          </li>
                        ))}
                      </ul>
                    </Box>

                    <Box className="mt-8 p-4 bg-gray-100 rounded-lg border border-gray-300">
                      <Typography
                        variant="body2"
                        className="text-gray-700 italic"
                      >
                        <sup>1.</sup> এটি একটি প্রাথমিক রূপরেখা। রেজিস্টার্ড
                        ডাক্তারের পরামর্শ নিয়ে ওষুধ সেবন করুন।
                      </Typography>
                    </Box>

                    {/* Feedback Section */}
                    <Box className="mt-6 p-4 bg-gray-50 rounded-lg border border-gray-200 flex flex-col ">
                      <Typography
                        variant="h6"
                        className="font-semibold mb-3 text-blue-600"
                      >
                        আপনার মতামত দিন
                      </Typography>

                      <FormControl component="fieldset" className="mb-4 w-full">
                        <div
                          // component="legend"
                          className="text-gray-700 mb-2"
                        >
                          এই উপদেশ কি আপনার জন্য সহায়ক ছিল?
                        </div>
                        <RadioGroup
                          row
                          name="feedback"
                          value={feedbackValue}
                          onChange={handleFeedbackChange}
                          className="flex justify-start gap-4"
                        >
                          <FormControlLabel
                            value={1}
                            control={<Radio />}
                            label={
                              <Box className="flex items-center">
                                <ThumbUp
                                  className="text-green-600 mr-1"
                                  fontSize="small"
                                />
                                <span>সহায়ক</span>
                              </Box>
                            }
                            disabled={submitted}
                          />
                          <FormControlLabel
                            value={0}
                            control={<Radio />}
                            label={
                              <Box className="flex items-center">
                                <ThumbDown
                                  className="text-red-600 mr-1"
                                  fontSize="small"
                                />
                                <span>সহায়ক নয়</span>
                              </Box>
                            }
                            disabled={submitted}
                          />
                        </RadioGroup>
                      </FormControl>

                      <Box className="flex flex-col gap-4">
                        <TextField
                          fullWidth
                          label="আপনার মন্তব্য"
                          multiline
                          rows={3}
                          variant="outlined"
                          value={comment}
                          onChange={(e) => {
                            if (e.target.value.length <= 300) {
                              handleCommentChange(e);
                            }
                          }}
                          className="mb-4"
                          placeholder="আপনার যেকোন মতামত এখানে লিখুন..."
                          disabled={submitted}
                        />
                        <Box>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmitFeedback}
                            disabled={(!feedbackValue && !comment) || submitted}
                            startIcon={<Send />}
                            className="bg-blue-600 hover:bg-blue-700"
                          >
                            মতামত জমা দিন
                          </Button>
                        </Box>
                      </Box>

                      {submitted && (
                        <Typography className="mt-2 text-green-600 italic">
                          আপনার মতামত জমা দেওয়া হয়েছে। ধন্যবাদ!
                        </Typography>
                      )}
                    </Box>

                    <Box className="flex flex-wrap gap-4 mt-6 items-center justify-center">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handlePrint}
                        className="bg-blue-600 hover:bg-blue-700"
                        startIcon={<Print />}
                      >
                        উপদেশ প্রিন্ট করুন
                      </Button>

                      <Button
                        variant="contained"
                        color="error"
                        onClick={handleRefresh}
                        className="bg-red-600 hover:bg-red-700"
                        startIcon={<Refresh />}
                      >
                        পুনরায় শুরু করুন
                      </Button>
                    </Box>

                    {!auth.isAuthenticated && (
                      <Box className="mt-6 p-4 bg-gray-100 rounded-lg text-center w-full border">
                        <Typography
                          variant="body1"
                          className="text-gray-800 !mb-2"
                        >
                          আপনার উপদেশগুলি সংরক্ষণ করতে লগ ইন করুন
                        </Typography>
                        <LoadingButton
                          variant="outlined"
                          color="primary"
                          className="mt-2"
                          startIcon={<AccountCircle />}
                          onClick={auth.signinRedirect}
                          loadingPosition="start"
                          loading={auth.isLoading}
                        >
                          লগইন করুন
                        </LoadingButton>
                      </Box>
                    )}
                  </Box>
                </Paper>
              </Zoom>
            </Box>
          )}

          {!isComplete && (
            <Box className="h-full">
              <Box className="pb-32">
                <CardContent className="flex flex-col gap-4">
                  {Array.from(
                    { length: currentIndex - 1 },
                    (_, i) => i + 1
                  ).map((index) => (
                    <Box key={index} className="flex flex-col gap-2">
                      <AssistantChat message={formData[`q${index}`]} />
                      <UserChat
                        message={formData[`a${index}`]}
                        gender={formData.gender}
                      />
                    </Box>
                  ))}

                  <AssistantChat
                    message={formData[`q${currentIndex}`]}
                    ref={messagesEndRef}
                  />
                </CardContent>
              </Box>

              <Box className="fixed bottom-0 max-w-2xl inset-x-0 mx-auto">
                <Box className="px-4">
                  <TextField
                    autoFocus
                    name={`a${currentIndex}`}
                    value={formData[`a${currentIndex}`]}
                    onChange={handleChange}
                    variant="filled"
                    fullWidth
                    placeholder="আপনার উত্তর..."
                    className="bg-white my-4"
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !isLoading) {
                        e.preventDefault(); // Prevents form submission (if inside a form)
                        handleNext(); // Calls the next function
                      }
                    }}
                    // disabled={isLoading}
                  />
                  <Box
                    className="flex flex-row justify-between items-center w-full mb-4 rounded-b-3xl p-2 bg-[#F0F0F0]"
                    style={{ border: "1px solid #ccc" }}
                  >
                    <Box className="flex flex-row gap-2">
                      <Typography
                        variant="body2"
                        className="text-white bg-gray-400 p-1 rounded-md"
                      >
                        বয়স: {formData.age} বছর
                      </Typography>
                      <Typography
                        variant="body2"
                        className="text-white bg-gray-400 p-1 rounded-md"
                      >
                        লিঙ্গ:{" "}
                        {formData.gender === "male"
                          ? "পুরুষ"
                          : formData.gender === "female"
                          ? "মহিলা"
                          : formData.gender === "other"
                          ? "অন্যান্য"
                          : ""}
                      </Typography>
                    </Box>

                    <IconButton
                      onClick={handleNext}
                      loading={isLoading}
                      className="h-9 w-9 bg-blue-600"
                      sx={{
                        backgroundColor: "blue",
                        color: "white",
                        "&:hover": {
                          color: "gray",
                        },
                      }}
                    >
                      {!isLoading && <ArrowUpward />}
                    </IconButton>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default QuestionnaireFormIntake;
